import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppSettingsService } from '@dabnet-kamu/libs/ui/shared/services/app-settings.service';

// FontAwesome importları
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';   // tüm solid ikonlar


async function loadAppSettings() {
  const appSettings = new AppSettingsService();
  await appSettings.loadAppSettings();
}

loadAppSettings().then(() => {
  bootstrapApplication(AppComponent, appConfig).then(appRef => {
    // 🔥 Global ikon setlerini buraya ekliyoruz
    const library = appRef.injector.get(FaIconLibrary);
    library.addIconPacks(fas);
  }).catch((err) => console.error(err));
});









// import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { AppComponent } from './app/app.component';
// import {AppSettingsService} from '@dabnet-kamu/libs/ui/shared/services/app-settings.service';
//
//
// async function loadAppSettings() {
//
//   const appSettings=new AppSettingsService();
//   await appSettings.loadAppSettings();
//
// }
//
//
//
// loadAppSettings().then(() => {
//   bootstrapApplication(AppComponent, appConfig).catch((err) =>
//     console.error(err)
//   );
// });

